import { gql } from '@apollo/client'
import { PICOS_PRIORITY_FRAGMENT } from '../fragments'

export const GET_PICOS_PRIORITY = gql`
  query GetPicOSPriority($priorityId: ID!) {
    picosPriority(priorityId: $priorityId) {
      ...PicOSPriority
    }
  }
  ${PICOS_PRIORITY_FRAGMENT}
`
